import axios from 'axios';
import {CommonFile} from '../admin/documents/api';

export interface FileData {
    id: number;
    type: string;
    fileName: string;
    dateUpload: string;
    fileSize: number;
    system: string;
}

export interface SortedFiles {
    commercial: FileData[];
    technique: FileData[];
    administratif: FileData[];
    fibre: FileData[];
    rapportRoc: FileData[];
    serviceClient: FileData[];
}

const DOWNLOAD_FILE: string = '/api/files/:id/download';
const DOWNLOAD_PAGE: string = '/documents/download/:id';
const GET_FILES: string = 'files';
const GET_LAST_FILES: string = 'files/last';

export const getDownloadURL = (id: number, system: string): string => {
    return (
        axios.defaults.baseURL +
        DOWNLOAD_FILE.replace(':id', id.toString()) +
        `?system=${encodeURIComponent(system)}`
    );
};

export const getFileURL = (file: FileData | CommonFile): string => {
    return getDownloadURL(file.id, file.system);
};

/**
 * Lien classique (route du front protégée par l'auth habituelle) qui déclenche le téléchargement du fichier.
 * Il peut être ouvert dans un nouvel onglet, copié ou partagé, contrairement à l'URL de l'API qui exige le JWT.
 * @param file
 */
export const getShareableFileURL = (file: FileData | CommonFile): string => {
    return (
        DOWNLOAD_PAGE.replace(':id', file.id.toString()) +
        `?system=${encodeURIComponent(file.system)}`
    );
};

/**
 * Télécharge le fichier à travers axios pour avoir le JWT dans le header
 * (contrairement à un href qui ne l'a pas car on ne controle pas les headers et nous n'utilisaons pas de cookies))
 * @param fileURL
 */
export const downloadFile = async (fileURL: string): Promise<void> => {
    const response = await axios.get(fileURL, {responseType: 'blob'});
    let filename = response.headers['content-disposition'].split('filename=')[1].split('.')[0];
    let extension = response.headers['content-disposition'].split('.')[1].split(';')[0];
    const href = URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', filename + '.' + extension); //or any other extension
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(href);
};

export const getFiles = async (langue: string): Promise<SortedFiles> => {
    const {data} = await axios.get<SortedFiles>('/api/' + GET_FILES, {params: {langue}});
    return data;
};

export const getLastFiles = async (): Promise<FileData[]> => {
    const {data} = await axios.get<FileData[]>('/api/' + GET_LAST_FILES);
    return data;
};
